



































import Vue, { PropType } from "vue"
import PCardList from "./PCardList.vue"
import PCardListItem from "./PCardListItem.vue"
import CInfiniteScrollList, {
  emitEventWhenTouchBottom,
} from "~/components/custom/baseList/CInfiniteScrollList.vue"
import { ProjectView, decorateProjectView } from "~/backendApis/viewModel"
import { projectDecorator } from "~/backendApis/viewModel/decorator"

export interface ClickFavoriteIconEmitArgument {
  projectId: string
}

export default Vue.extend({
  components: {
    PCardList,
    PCardListItem,
    CInfiniteScrollList,
  },
  props: {
    projects: {
      type: Array as PropType<ProjectView[]>,
      required: true,
    },
    isFetchableNext: {
      type: Boolean,
      required: true,
    },
    enableFavorite: {
      type: Boolean,
      required: true,
    },
    favoriteProjectIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  computed: {
    emitEvents() {
      return { emitEventWhenTouchBottom }
    },
  },
  methods: {
    corporationLogoImageUrl(project: ProjectView): string {
      return project.corporationLogoImage
        ? this.$clHelpers.thumbnail.generateURL({
            image: project.corporationLogoImage,
            width: 50,
            height: 50,
          })
        : ""
    },
    projectFeatureTexts(project: ProjectView): string[] {
      return decorateProjectView(project).featureTexts()
    },
    isClosedApplication(project: ProjectView): boolean {
      return decorateProjectView(project).isClosedApplication()
    },
    handleTouchBottomOfProfileList() {
      this.$emit("touch-bottom-of-project-list")
    },
    handleClickFavoriteIcon(projectId: string) {
      const arg: ClickFavoriteIconEmitArgument = {
        projectId,
      }
      this.$emit("click-favorite-icon", arg)
    },
    isFavoriteProject(projectId: string): boolean {
      return this.favoriteProjectIds.includes(projectId)
    },
    getMonthDate(project: ProjectView): string {
      return decorateProjectView(project).getMonthDate()
    },
    getPublishedLimitDate(project: ProjectView): string {
      return decorateProjectView(project).getPublishedLimitDate()
    },
    getPublishedEndDate(project: ProjectView): string {
      return decorateProjectView(project).getPublishedEndDate()
    },
    isNewProject(project: ProjectView): boolean {
      return projectDecorator(project).isNew
    },
    getHeaderImageLargeJobCategoryId(project: ProjectView): number {
      return decorateProjectView(project).getHeaderImageLargeJobCategoryId()
    },
    getHeaderImagePatternNo(project: ProjectView): number {
      return decorateProjectView(project).getHeaderImagePatternNo()
    },
  },
})
